module.exports = __webpack_public_path__ + "img/partner18.b29abc0e.jpg";